import { useTranslation } from 'react-i18next';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function LoadingSpinner({ size = 'md', className = '' }: LoadingSpinnerProps) {
  const { t } = useTranslation('brand');
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  return (
    <span role="status" className={`${size === 'lg' ? 'brand-loader' : 'inline-block animate-spin rounded-full border-2 border-current border-t-transparent'} ${sizeClasses[size]} ${className}`}>
      {size === 'lg' && <img src="/branding/pwa-192.png" alt="" width="48" height="48" />}
      <span className="sr-only">{t('loading')}</span>
    </span>
  );
}
